import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

import { SanitizeHtmlPipe } from '../../pipe/sanitize-html.pipe';
import { SanitizeUrlPipe } from '../../pipe/sanitize-url.pipe';


interface CommonDialogMessageData {
	title?: string;
	content?: string;
	contentIframeUrl?: string;
	contentLoader?: boolean;
	contentIcon?: string;
	buttons?: Array<CommonDialogMessageDataButton>;
	close?: boolean;
	debug?: () => void;
	debugId?: string;
}

interface CommonDialogMessageDataButton {
	title: string;
	iconLeft?: string;
	iconRight?: string;
	click?: () => void;
}

@Component({
	templateUrl: './message.component.html',
	styleUrls: ['./message.component.scss'],
	imports: [
		MatIcon, MatDialogTitle, MatDialogContent, MatProgressSpinner, MatDialogActions, MatButton, SanitizeHtmlPipe, SanitizeUrlPipe
	]
})
export class CommonDialogMessage {
	constructor(
		private dialogRef: MatDialogRef<CommonDialogMessage>,
		@Inject(MAT_DIALOG_DATA) public data: CommonDialogMessageData | null = null,
	) {}

	public close() {
		this.dialogRef.close();
	}

	public buttonClick(button: CommonDialogMessageDataButton) {
		if (button.click !== undefined) {
			button.click();
		} else {
			this.close();
		}
	}

	public debugClick() {
		if (this.data !== null
			&& this.data.debug !== undefined) {
			this.data.debug();
		}
	}
}
